import { AnchorButton } from "@govlaunch/core";
import * as palette from "@govlaunch/palette";
import React, { ReactNode } from "react";

import MakersIcon from "~/components/icons/MakersIcon";
import UpgradeDrawIcon from "~/components/icons/UpgradeDrawIcon";
import { Margin } from "~/components/spacings";
import { FormattedMessage } from "react-intl";
import Link from "next/link";
import { CHOOSE_YOUR_PLAN_CONTAINER_ID } from "~/components/makers/MakersPageHeader";

interface IUpgradeAccountBannerProps {
  icon?: ReactNode;
  title?: string;
  plan?: string;
  description?: string;
  linkToHref?: string;
  linkProps?: Record<string, any>;
}

export default function UpgradeAccountBanner({
  icon,
  title = "Upgrade to Makers",
  description = "Access a powerful suite of tools to help you showcase you products and connect with local governent innovators.",
  plan = "Makers",
  linkToHref = "/makers",
  linkProps = {},
}: IUpgradeAccountBannerProps) {
  return (
    <div
      css={{
        borderRadius: 4,
        border: `1px solid ${palette.lightestGray}`,
        background: "#fff",
        textAlign: "center",
        padding: 32,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {icon || <MakersIcon width={80} height={80} />}

      <h1
        css={{
          fontSize: 36,
          fontWeight: 800,
          margin: "8px 0 8px",
          color: palette.text,
        }}
      >
        {title}
      </h1>

      <div
        css={{
          color: palette.mediumGray,
          textAlign: "center",
          marginBottom: 24,
          maxWidth: 500,
          fontSize: 18,
        }}
      >
        {description}
      </div>

      <div>
        <UpgradeDrawIcon />
      </div>

      <Link href={`${linkToHref}#${CHOOSE_YOUR_PLAN_CONTAINER_ID}`} {...linkProps} passHref={true}>
        <AnchorButton
          size="large"
          theme="primary"
          color={palette.greenSuccess}
          textColor={palette.white}
          css={{ minWidth: 300, marginTop: 24 }}
        >
          <FormattedMessage defaultMessage="Upgrade" id="0h/lPM" />
        </AnchorButton>
      </Link>

      <Margin mt={12}>
        <Link href={linkToHref} {...linkProps} passHref={true}>
          <a
            css={{
              color: palette.innovatorBlue,
              fontSize: 14,
            }}
          >
            Learn more about{" "}
            <span
              css={{
                fontWeight: 600,
              }}
            >
              {plan}
            </span>
          </a>
        </Link>
      </Margin>
    </div>
  );
}
